"use strict";
// const BASE_URL = "http://127.0.0.1/api_hicare/";
const BASE_URL = "https://hicare.tech/";

const Config = {
  BASE_URL,
};

export default Config;
